import { AbstractCommand } from 'src/models/command';

/**
 * Setzt (`templateId > 0`) oder entfernt (`templateId = 0`) die Standardvorlage des angemeldeten
 * Users fuer ein Sendekonto. Explizite Semantik, kein Toggle.
 */
class SetTheStandardMailTemplateForTheAccountCommand extends AbstractCommand {
	readonly name = 'IFS_Mail_Command_Command_SetTheStandardMailTemplateForTheAccountCommand';

	public constructor(postboxId: number, templateId: number) {
		super();
		this.parameters = {
			postboxId: postboxId,
			templateId: templateId,
		};
	}
}

export { SetTheStandardMailTemplateForTheAccountCommand };
